import { render, staticRenderFns } from "./Activatable.vue?vue&type=template&id=ecd34238&"
import script from "./Activatable.vue?vue&type=script&lang=js&"
export * from "./Activatable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports